export class UnauthenticatedError extends Error {
}